/**
 * 正整数不包含0
 * @param {*} s
 */
 export const IntegerWithOutZeroPattern = /^[1-9]\d*$/

 /**
 * 正整数包含0
 * @param {*} s
 */
  export const IntegerWithZeroPattern = /^[0-9]\d*$/

  /**
 * 身份证号
 * @param {*} s
 */
 // export const CardIdNumberPattern = /(^\d{15}$)|(^\d{17}([0-9]|X|x)$)/
 export const CardIdNumberPattern = /(^\d{17}([0-9]|X|x)$)/

 /**
 * 手机号
 * @param {*} s
 */
  export const PhoneNumberPattern = /^1[3456789]\d{9}$/
